import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=04a0d67a&scoped=true&"
import script from "./Loader.vue?vue&type=script&lang=ts&"
export * from "./Loader.vue?vue&type=script&lang=ts&"
import style0 from "./Loader.vue?vue&type=style&index=0&id=04a0d67a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a0d67a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/cypher.team.viz/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04a0d67a')) {
      api.createRecord('04a0d67a', component.options)
    } else {
      api.reload('04a0d67a', component.options)
    }
    module.hot.accept("./Loader.vue?vue&type=template&id=04a0d67a&scoped=true&", function () {
      api.rerender('04a0d67a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Loader.vue"
export default component.exports